import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { IconButton, Button, Menu, MenuItem, Popover } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import './activity-calendar.scss';
import {
  ACTIVATED_STATUS,
  CALENDAR_VIEW,
  DAY,
  SCHEDULE_TYPES,
} from '../../../../constants/ActivityCalendarConst';
import { ArrowBack, ArrowForward } from '@material-ui/icons';

const localizer = momentLocalizer(moment);
const CustomDayWeekCell = ({ children, date }) => {
  return (
    <div>
      <>
        <div className='weekDay'>
          {moment(date).format('ddd')?.toUpperCase()} <br />
          {moment(date).format('DD')}
        </div>
      </>
    </div>
  );
};
const CustomCalendarHeader = (props) => {
  const { label, onNavigate, onView, calendarView, setCalendarView, date, setSelectedDate } = props;
  const [viewAnchorEl, setViewAnchorEl] = useState(null);

  const handlePrev = () => {
    let setDate = new Date(date);
    if (calendarView === CALENDAR_VIEW[2]?.id) {
      setDate.setMonth(setDate.getMonth() - 1);
    } else if (calendarView === CALENDAR_VIEW[1]?.id) {
      setDate.setDate(setDate.getDate() - 7);
    } else if (calendarView === CALENDAR_VIEW[0]?.id) {
      setDate.setDate(setDate.getDate() - 1);
    }
    setSelectedDate(setDate);
  };

  const handleNext = () => {
    let setDate = new Date(date);
    if (calendarView === CALENDAR_VIEW[2]?.id) {
      setDate.setMonth(setDate.getMonth() + 1);
    } else if (calendarView === CALENDAR_VIEW[1]?.id) {
      setDate.setDate(setDate.getDate() + 7);
    } else if (calendarView === CALENDAR_VIEW[0]?.id) {
      setDate.setDate(setDate.getDate() + 1);
    }
    setSelectedDate(setDate);
  };

  const handleViewChange = (e) => {
    const newView = e?.target?.value;
    onView(newView);
    setCalendarView(newView);
    if (CALENDAR_VIEW?.some((view) => view?.id === newView)) {
      setSelectedDate(new Date());
    }
  };

  const showLabel = () => {
    if (calendarView === CALENDAR_VIEW[0]?.id) {
      return moment(date).format('Do MMM, dddd');
    } else if (calendarView === CALENDAR_VIEW[2]?.id) {
      return moment(date).format('MMMM');
    } else {
      const weekDay = label?.split('–');
      const startWeek = moment(weekDay[0], 'MMMM DD');
      let EndWeek = null;
      if (weekDay[1]?.split(' ')?.length === 3) {
        EndWeek = moment(weekDay[1], 'MMMM DD');
      } else {
        const endWeekDate = weekDay[1] + ' ' + startWeek.format('MMMM');
        EndWeek = moment(endWeekDate, 'DD MMMM');
      }
      return `${startWeek.format('Do MMM')} to ${EndWeek.format('Do MMM')}`;
    }
  };

  return (
    <div className='d-flex mb-3 justify-content-between'>
      <div className='d-flex align-items-center '>
        <IconButton onClick={handlePrev} className='activityBtn'>
          <ArrowBack />
        </IconButton>
        <div className='activitySelectedDate'>{showLabel()}</div>
        <IconButton onClick={handleNext} className='activityBtn'>
          <ArrowForward />
        </IconButton>
      </div>
      <div className='kebab-menu'>
        <Button
          aria-controls='view-menu'
          aria-haspopup='true'
          className='view-dropdown-button gray-outlined-button'
          size='medium'
          variant='outlined'
          disableRipple
          endIcon={<KeyboardArrowDownIcon className='gray-arrow-icon' />}
          onClick={(e) => setViewAnchorEl(e.currentTarget)}
        >
          {CALENDAR_VIEW?.find((view) => view?.id === calendarView)?.name || 'Day View'}
        </Button>
        <Menu
          id={'viewSelector'}
          anchorEl={viewAnchorEl}
          keepMounted
          open={Boolean(viewAnchorEl)}
          className='shadow menuSection'
          onClose={() => {
            setViewAnchorEl(null);
            document?.activeElement?.blur();
          }}
        >
          {CALENDAR_VIEW?.map((view) => (
            <MenuItem
              key={view?.id}
              value={view?.id}
              className='menuList'
              onClick={() => {
                handleViewChange({ target: { value: view?.id } });
                setViewAnchorEl(null);
              }}
            >
              {view?.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
};

const CustomEventComponent = (props) => {
  return (
    <div
      className='eventCard'
      style={{
        fontSize: '8px',
        fontWeight: 500,
        textAlign: 'left',
        borderLeft: props?.event?.color ? `9px solid ${props?.event?.color}` : '',
      }}
    >
      <div style={{ width: '100%' }}>{props?.event?.title}</div>
    </div>
  );
};
const CustomEventComponentWeek = (props) => {
  const duration = moment(props?.event?.end)?.diff(moment(props?.event?.start), 'minutes');
  const isShort = duration < 30;

  return (
    <div
      className={`eventCard weekEventCard ${isShort ? 'shortEvent' : ''}`}
      title={`${props?.event?.title} (${moment(props?.event?.start)?.format('hh:mm A')} - ${moment(
        props?.event?.end,
      ).format('hh:mm A')})`}
      style={{
        borderLeft: props?.event?.color ? `9px solid ${props?.event?.color}` : '',
        fontSize: '8px',
      }}
    >
      <div className='weekEventTitle'>{props?.event?.title}</div>
      <div className='weekEventTime'>
        {moment(props?.event?.start)?.format('hh:mm A')} -{' '}
        {moment(props?.event?.end)?.format('hh:mm A')}
      </div>
    </div>
  );
};
const CustomEventDayComponent = (props) => {
  const duration = moment?.duration(moment(props?.event?.end)?.diff(moment(props?.event?.start)));
  const isLessThanHour = duration?.asHours() < 1;
  return (
    <div
      className='eventCard dayEvent'
      style={props?.event?.color ? { borderLeft: `9px solid ${props?.event?.color}` } : {}}
    >
      <div>
        <div style={{ paddingBottom: '10px' }}>
          <span style={{ fontWeight: 500 }}>
            {isLessThanHour ? (
              <span>
                {props?.event?.title} {moment(props?.event?.start)?.format('hh:mm A')} {' - '}
                {moment(props?.event?.end)?.format('hh:mm A')}
              </span>
            ) : (
              <>
                {props?.event?.title}
                {props?.event?.location && ` - ${props?.event?.location}`}
              </>
            )}
          </span>
        </div>
        {!isLessThanHour && (
          <div>
            {moment(props?.event?.start)?.format('hh:mm A')} {' - '}
            {moment(props?.event?.end)?.format('hh:mm A')}
          </div>
        )}
      </div>
    </div>
  );
};

const getEventCounts = (defaultEvents) => {
  const eventCounts = {};
  defaultEvents?.forEach((event) => {
    const date = moment(event?.start).format('YYYY-MM-DD');
    if (eventCounts[date]) {
      eventCounts[date]++;
    } else {
      eventCounts[date] = 1;
    }
  });

  return eventCounts;
};

const CustomDayCell = (props) => {
  const eventCounts = getEventCounts(props?.defaultEvents);
  const date = moment(props?.date).format('YYYY-MM-DD');
  const count = eventCounts[date] || 0;
  return (
    <>
      <div
        className='d-flex justify-content-between'
        style={{ marginTop: 8, marginLeft: 12, alignItems: 'center' }}
        onClick={() => {
          props?.setCalendarView('day');
        }}
      >
        <div className='data'>{moment(props?.date).format('DD')}</div>
        {count > 0 && (
          <div className='eventCount'>
            {count} {count === 1 ? 'event' : 'events'}
          </div>
        )}
      </div>
    </>
  );
};

const ActivityCalendar = ({
  eventList,
  selectedDate,
  setSelectedDate,
  location,
  calendarView,
  setCalendarView,
}) => {
  const [defaultEvents, setDefaultEvents] = useState([]);
  const [popAnchor, setPopAnchor] = useState(null);
  const [currentPopoverDate, setCurrentPopoverDate] = useState('');

  const alwaysActiveEvents = defaultEvents?.filter((e) => e?.alwaysActive);

  useEffect(() => {
    handleEventFormat(eventList);
  }, [eventList]);

  const getLocation = (locationId) => {
    if (locationId) {
      return location.find((item) => item?.id === locationId)?.name || '';
    }
    return '';
  };

  const handleEventFormat = (events) => {
    let createList = [];
    events
      ?.filter((event) => event?.status === ACTIVATED_STATUS)
      ?.forEach((item) => {
        if (item?.schedule?.scheduleType === SCHEDULE_TYPES[0]) {
          let startDate = moment(
            item?.schedule?.oneTime?.date + ' ' + item?.schedule?.startTime,
            'DD-MM-YYYY HH:mm',
          );
          let endDate = moment(
            item?.schedule?.oneTime?.date + ' ' + item?.schedule?.endTime,
            'DD-MM-YYYY HH:mm',
          );
          createList?.push({
            title: item?.name,
            color: item?.label,
            start: new Date(startDate?.toDate()),
            end: new Date(endDate?.toDate()),
            location: getLocation(item?.location),
          });
        } else if (item?.schedule?.scheduleType === SCHEDULE_TYPES[1]) {
          const startDate = moment(item?.schedule?.recurring?.startDate, 'DD-MM-YYYY');
          const endDate = moment(item?.schedule?.recurring?.endDate, 'DD-MM-YYYY');
          if (!startDate.isValid() || !endDate.isValid()) return;
          const timeSlots = item?.schedule?.recurring?.recurringTimeSlots || [
            {
              startTime: item?.schedule?.startTime,
              endTime: item?.schedule?.endTime,
            },
          ];
          const recurs = item?.schedule?.recurring?.recurs;
          if (!recurs) return;
          const recursWeek = item?.schedule?.recurring?.recursWeek || [];
          const recursDates = item?.schedule?.recurring?.dates?.[0]?.split(',') || [];
          let currentDate = startDate?.clone();
          while (currentDate?.isSameOrBefore(endDate)) {
            const isRecurringDay =
              recurs === DAY ||
              (recurs === 'WEEK' &&
                (!recursWeek.length || recursWeek.includes(currentDate?.format('dddd').toUpperCase()))) ||
              (recurs === 'MONTH' && (!recursDates.length || !recursDates[0] || recursDates.includes(currentDate?.format('D'))));

            if (isRecurringDay) {
              timeSlots.forEach((slot) => {
                const eventStart = moment(
                  `${currentDate?.format('DD-MM-YYYY')} ${
                    slot?.startTime || item?.schedule?.startTime
                  }`,
                  'DD-MM-YYYY HH:mm',
                );
                const eventEnd = moment(
                  `${currentDate?.format('DD-MM-YYYY')} ${
                    slot?.endTime || item?.schedule?.endTime
                  }`,
                  'DD-MM-YYYY HH:mm',
                );
                if (eventEnd?.isBefore(eventStart)) {
                  eventEnd?.add(1, 'day');
                }
                createList.push({
                  title: item?.name,
                  color: item?.label,
                  start: eventStart?.toDate(),
                  end: eventEnd?.toDate(),
                  location: getLocation(item?.location),
                  recurringEvent: true,
                });
              });
            }
            currentDate?.add(1, 'day');
          }
        } else if (item?.schedule?.scheduleType === SCHEDULE_TYPES[3]) {
          const date = new Date(item?.createdAt * 1000);
          const startTime = item?.schedule?.startTime?.split(':');
          let startDate = new Date(date?.setHours(startTime[0], startTime[1]));
          let setStartDate = moment(startDate);
          for (let day = 0; day < 365; day++) {
            const eventStart = setStartDate.clone();
            const eventEnd = moment(
              setStartDate?.format('DD-MM-YYYY') + ' ' + item?.schedule?.endTime,
              'DD-MM-YYYY HH:mm',
            );

            createList.push({
              title: item?.name,
              color: item?.label,
              start: eventStart?.toDate(),
              end: eventEnd?.toDate(),
              location: getLocation(item?.location),
              alwaysActive: true,
              alwaysActive: true,
            });
            setStartDate?.add(1, 'day');
          }
        }
      });
    setDefaultEvents(createList);
  };

  const formats = {
    weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dddd', culture),
  };

  const customCalendarComponent = {
    toolbar: (props) => (
      <CustomCalendarHeader
        {...props}
        onView={props.onView}
        onNavigate={props.onNavigate}
        calendarView={calendarView}
        setCalendarView={setCalendarView}
        setSelectedDate={setSelectedDate}
      />
    ),
    month: {
      dateHeader: (props) => (
        <CustomDayCell {...props} defaultEvents={defaultEvents} setCalendarView={setCalendarView} />
      ),
      event: (props) => <CustomEventComponent {...props} />,
    },
    week: {
      header: (props) => (
        <CustomDayWeekCell
          {...props}
          defaultEvents={defaultEvents}
          setCalendarView={setCalendarView}
        />
      ),
      event: (props) => <CustomEventComponentWeek {...props} />,
    },
    day: {
      header: (props) => (
        <CustomDayWeekCell
          {...props}
          defaultEvents={defaultEvents}
          setCalendarView={setCalendarView}
        />
      ),
      event: (props) => <CustomEventDayComponent {...props} />,
    },
  };

  return (
    <div className='calendar-container'>
      <Calendar
        localizer={localizer}
        events={defaultEvents}
        startAccessor='start'
        date={selectedDate}
        endAccessor='end'
        onNavigate={(newDate) => {
          setSelectedDate(new Date(newDate));
        }}
        onRangeChange={(range) => {
          if (Array.isArray(range)) {
            setSelectedDate(new Date(range[0]));
          } else if (range?.start) {
            setSelectedDate(new Date(range?.start));
          }
        }}
        view={calendarView}
        onView={(view) => setCalendarView(view)}
        className={`custom-calendar 
  ${calendarView === CALENDAR_VIEW[0]?.id ? 'day-view--scroll-x' : ''} 
  ${
    (calendarView === CALENDAR_VIEW[1]?.id && alwaysActiveEvents?.length > 0) ||
    (calendarView === CALENDAR_VIEW[2]?.id && alwaysActiveEvents?.length > 0)
      ? 'always-active-block'
      : ''
  }
`}
        dayLayoutAlgorithm='no-overlap'
        style={{ height: 820 }}
        components={customCalendarComponent}
        formats={formats}
      />
      {calendarView === CALENDAR_VIEW[0]?.id &&
        (() => {
          const uniqueAlwaysActive = Array.from(
            new Map(alwaysActiveEvents?.map((ev) => [`${ev?.title}-${ev?.color}`, ev]))?.values(),
          );
          return (
            <>
              <div className='utc-gutter-corner'>UTC</div>

              <div className='utc-always-active-day-view'>
                <div className='always-active-day-list'>
                  {uniqueAlwaysActive?.slice(0, 3)?.map((ev, idx) => (
                    <div
                      key={`${ev?.title}-${ev?.color}`}
                      className='always-active-day-item'
                      style={
                        ev?.color && ev?.color.toLowerCase() === '#ffffff'
                          ? { borderLeft: '1px solid #ccc', paddingLeft: '18px' }
                          : { borderLeft: `9px solid ${ev?.color}` }
                      }
                    >
                      {ev?.title}
                    </div>
                  ))}
                  {uniqueAlwaysActive?.length > 3 && (
                    <div
                      className='always-active-more'
                      onClick={(e) => {
                        setPopAnchor(e?.currentTarget);
                        setCurrentPopoverDate('day');
                      }}
                    >
                      +{uniqueAlwaysActive?.length - 3} more
                    </div>
                  )}
                </div>
              </div>
              <Popover
                open={Boolean(popAnchor) && currentPopoverDate === 'day'}
                anchorEl={popAnchor}
                onClose={() => setPopAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{
                  className: 'custom-popover-paper',
                }}
              >
                <div className='custom-popover-content'>
                  <div className='custom-popover-header'>
                    <IconButton size='small' onClick={() => setPopAnchor(null)}>
                      <span style={{ width: '10px', color: '#999999', fontWeight: 300 }}>×</span>
                    </IconButton>
                  </div>
                  <div className='custom-popover-body'>
                    {uniqueAlwaysActive?.map((ev, idx) => (
                      <div
                        key={`${ev?.title}-${ev?.color}`}
                        className='custom-popover-item'
                        style={
                          ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                            ? { borderLeft: '1px solid #ccc' }
                            : { borderLeft: `9px solid ${ev?.color}` }
                        }
                      >
                        <div
                          className='custom-popover-title'
                          style={
                            ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                              ? { paddingLeft: '8px' }
                              : {}
                          }
                        >
                          {ev?.title}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Popover>
            </>
          );
        })()}

      {calendarView === CALENDAR_VIEW[1]?.id &&
        (() => {
          const uniqueAlwaysActive = Array.from(
            new Map(alwaysActiveEvents?.map((ev) => [`${ev?.title}-${ev?.color}`, ev]))?.values(),
          );
          return (
            <>
              <div className='always-active-week-header'>
                {uniqueAlwaysActive?.slice(0, 3)?.map((ev, idx) => (
                  <div
                    key={`${ev?.title}-${ev?.color}`}
                    className='always-active-week-item'
                    style={
                      ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                        ? { borderLeft: '1px solid #ccc', paddingLeft: '16px' }
                        : { borderLeft: `9px solid ${ev?.color}` }
                    }
                  >
                    {ev.title}
                  </div>
                ))}
                {uniqueAlwaysActive?.length > 3 && (
                  <div
                    className='always-active-more'
                    onClick={(e) => {
                      setPopAnchor(e?.currentTarget);
                      setCurrentPopoverDate('week');
                    }}
                  >
                    +{uniqueAlwaysActive?.length - 3} more
                  </div>
                )}
              </div>
              <Popover
                open={Boolean(popAnchor) && currentPopoverDate === 'week'}
                anchorEl={popAnchor}
                onClose={() => setPopAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{
                  className: 'custom-popover-paper',
                }}
              >
                <div className='custom-popover-content'>
                  <div className='custom-popover-header'>
                    <IconButton size='small' onClick={() => setPopAnchor(null)}>
                      <span style={{ width: '10px', color: '#999999', fontWeight: 300 }}>×</span>
                    </IconButton>
                  </div>
                  <div className='custom-popover-body'>
                    {uniqueAlwaysActive?.map((ev, idx) => (
                      <div
                        key={`${ev?.title}-${ev?.color}`}
                        className='custom-popover-item'
                        style={
                          ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                            ? { borderLeft: '1px solid #ccc' }
                            : { borderLeft: `9px solid ${ev?.color}` }
                        }
                      >
                        <div
                          className='custom-popover-title'
                          style={
                            ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                              ? { paddingLeft: '8px' }
                              : {}
                          }
                        >
                          {ev?.title}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Popover>
            </>
          );
        })()}

      {calendarView === CALENDAR_VIEW[2]?.id &&
        (() => {
          const uniqueAlwaysActive = Array.from(
            new Map(alwaysActiveEvents?.map((ev) => [`${ev?.title}-${ev?.color}`, ev]))?.values(),
          );
          return (
            <>
              <div className='always-active-month-header'>
                {uniqueAlwaysActive?.slice(0, 3)?.map((ev, idx) => (
                  <div
                    key={`${ev?.title}-${ev?.color}`}
                    className='always-active-month-item'
                    style={
                      ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                        ? { borderLeft: '1px solid #ccc', paddingLeft: '16px' }
                        : { borderLeft: `9px solid ${ev.color}` }
                    }
                  >
                    <span className='always-active-title'>{ev?.title}</span>
                  </div>
                ))}
                {uniqueAlwaysActive.length > 3 && (
                  <div
                    className='always-active-more'
                    onClick={(e) => {
                      setPopAnchor(e?.currentTarget);
                      setCurrentPopoverDate('month');
                    }}
                  >
                    +{uniqueAlwaysActive?.length - 3} more
                  </div>
                )}
              </div>
              <Popover
                open={Boolean(popAnchor) && currentPopoverDate === 'month'}
                anchorEl={popAnchor}
                onClose={() => setPopAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{
                  className: 'custom-popover-paper',
                }}
              >
                <div className='custom-popover-content'>
                  <div className='custom-popover-header'>
                    <IconButton size='small' onClick={() => setPopAnchor(null)}>
                      <span style={{ width: '10px', color: '#999999', fontWeight: 300 }}>×</span>
                    </IconButton>
                  </div>
                  <div className='custom-popover-body'>
                    {uniqueAlwaysActive?.map((ev, idx) => (
                      <div
                        key={`${ev?.title}-${ev?.color}`}
                        className='custom-popover-item'
                        style={
                          ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                            ? { borderLeft: '1px solid #ccc' }
                            : { borderLeft: `9px solid ${ev?.color}` }
                        }
                      >
                        <div
                          className='custom-popover-title'
                          style={
                            ev?.color && ev?.color?.toLowerCase() === '#ffffff'
                              ? { paddingLeft: '8px' }
                              : {}
                          }
                        >
                          {ev?.title}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Popover>
            </>
          );
        })()}
    </div>
  );
};

export default ActivityCalendar;
